module.exports = __webpack_public_path__ + "static/media/Curoflow_develop_telemedicine_software_to_help_healthcare_workers.3efdac99.jpg";